import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getBreakpoint = createSelector((state) => get(state, 'headerState.breakpoint', 'sm'), (res) => res);
export const getLangCodeSelector = createSelector((state) => get(state, 'headerState.langCode', 'en'), (res) => res);
export const getAddress = createSelector((state) => get(state, 'designMyHouseData.address', {}), (res) => res);
export const getDMHState = createSelector((state) => get(state, 'designMyHouseData.DMHState', {}), (res) => res);

